// @ts-check
import React from 'react';
import { Flex, QRCode, Text, Title } from '../../pdf-design-system';

export default function ExampleContent() {
  return (
    <Flex
      style={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <QRCode
        url="http://vancouver2022.calwine.ca"
        style={{ height: '1.0in', width: '1.0in', marginBottom: '0.1in' }}
      />
      <Title style={{ fontSize: 18, marginBottom: '.2in' }}>
        Max Mustermann
      </Title>
      <Text style={{ fontSize: 14 }}>Wine Importers Anonymous</Text>
    </Flex>
  );
}
